import React from 'react';

/**
 * PiTagSolid icon from the solid style in general category.
 */
interface PiTagSolidProps extends React.SVGProps<SVGSVGElement> {
	size?: number;
	color?: string;
	className?: string;
	ariaLabel?: string;
}

export default function PiTagSolid({
	size = 24,
	color,
	className,
	ariaLabel = 'tag icon',
	...props
}: PiTagSolidProps): JSX.Element {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			style={{ color: color || 'currentColor' }}
			role="img"
			aria-label={ariaLabel}
			{...props}
		>
			<path
				d="M8.56536 2.06851C10.0052 1.99251 10.91 1.94475 11.7786 2.11974C12.5471 2.27458 13.2842 2.55741 13.959 2.95642C14.7216 3.40739 15.3622 4.04817 16.3816 5.06789L19.0422 7.72841C20.2226 8.90824 20.9861 9.6713 21.4186 10.5202C22.2906 12.2315 22.2906 14.2568 21.4186 15.9681C20.9861 16.817 20.2226 17.5801 19.0422 18.7599L18.7599 19.0422C17.5801 20.2226 16.817 20.9861 15.9681 21.4186C14.2568 22.2906 12.2315 22.2906 10.5202 21.4186C9.6713 20.9861 8.90826 20.2226 7.72841 19.0422L5.06789 16.3816C4.04817 15.3622 3.40739 14.7216 2.95642 13.959C2.55741 13.2842 2.27458 12.5471 2.11974 11.7786C1.94475 10.91 1.99251 10.0052 2.06851 8.56536L2.12104 7.56742C2.15943 6.83795 2.19124 6.23336 2.256 5.73945C2.32352 5.22452 2.43504 4.75288 2.67358 4.30811C3.04569 3.61428 3.61428 3.04569 4.30811 2.67358C4.75288 2.43504 5.22452 2.32352 5.73945 2.256C6.23337 2.19124 6.83795 2.15943 7.56743 2.12104L8.56536 2.06851ZM8.4895 6.48779C7.38493 6.48779 6.4895 7.38322 6.4895 8.48779C6.4895 9.59236 7.38493 10.4878 8.4895 10.4878C9.59407 10.4878 10.4895 9.59236 10.4895 8.48779C10.4895 7.38322 9.59407 6.48779 8.4895 6.48779Z"
				fill="currentColor"
			/>
		</svg>
	);
}
